// extracted by mini-css-extract-plugin
module.exports = {"container":"SideBar_container__YXuMb"};